<template>
  <panel title="7天销售趋势" class="mgb10">
    <ve-line :data="theadData" :extend="extend"></ve-line>
  </panel>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
import Util from "@/utils";
import Bargain from "@/api/bargain.js";

export default {
  components: { VeLine },
  data() {
    return {
      theadData: {
        columns: ["日期", "订单量"],
        rows: [],
      },
      records: [],
      extend: {
        series: {
          smooth: false,
        },
      },
    };
  },
  created() {
    const self = this;
    self.theadData.rows = [];
    Bargain.sevenDayCount().then(function (res) {
      if (res.status === 200) {
        self.records = res.data;
        for (const i in self.records) {
          self.theadData.rows.push({
            日期: Util.date(-(self.records.length - i - 1)),
            订单量: self.records[i],
          });
        }
      } else {
        self.sysError();
      }
    });
  },
};
</script>